import { Grid } from '@material-ui/core';
import './FileUpload.scss';
import { GroupFileUploadIconSVG } from './img/FileUploadSVG';
import useFileUpload from './hooks/useFileUpload';

const MultipleFileUpload = ({
  title = '',
  setFiles,
  files,
  isMultiSelect = true,
  fileType = [
    '.pdf',
    '.doc/',
    '.docx',
    '.xls',
    '.xlsx',
    '.png',
    '.bmp',
    '.ppt',
    '.pptx',
    '.jpg',
    '.jpeg',
    '.tiff',
    '.tif',
    '.odt',
    '.txt',
    '.zip',
  ],
  fileSize = 20 * 1048576, //30 * 1024
  className,
  name,
  setFieldValue,
  setMultiSelectFlag,
  browseFileSeactionFocus,
}) => {
  const { getRootProps, getInputProps, rejectedFiles, tempValidateFiles } =
    useFileUpload({
      setFiles,
      isMultiSelect,
      fileType,
      fileSize,
      files,
      setFieldValue,
      setMultiSelectFlag,
      browseFileSeactionFocus,
    });
  return (
    <>
      <Grid item>
        <div {...getRootProps()} ref={browseFileSeactionFocus}>
          <input {...getInputProps({ name: name })} />
          <div
            className={`mainGrid font-style mainGrid-padding-block ${className}`}
          >
            <div className="img-container-inline">
              <GroupFileUploadIconSVG />
            </div>
            <div className="inline-text">
              <span className="img-container">
                {title || 'Drag and Drop here '}
              </span>
              <div className="add-files-text">Click to Add Files </div> <br />
              <span className="or-text">
                {' '}
                Or <span className="browse-files">Browse File</span>
              </span>
            </div>
          </div>

          <div className="accepted-file-type" style={{ marginBottom: '20px' }}>
            The total file size should not exceed 20 MB.
            {/*Below line is commented based on Message and Documents Demo suggestion */}
            {/*Accepted file types:
            .pdf,.doc/.docx, .xls,.xlsx, .png, .bmp, .ppt, .pptx, .jpg, .jpeg,
            .tiff,.tif, .odt,.txt, .zip */}
          </div>
        </div>
      </Grid>
      <Grid item>
        {rejectedFiles.map((fileWrapper, idx) => (
          <div key={idx} className="rejectedFiles-class" id={idx} role="alert">
            {fileWrapper?.fileName} - {fileWrapper.error}
          </div>
        ))}
      </Grid>
      <Grid item>
        {tempValidateFiles ? (
          <div className="rejectedFiles-class" role="alert">
            The total file size should not exceed 20 MB.
          </div>
        ) : (
          ''
        )}
      </Grid>
    </>
  );
};

export default MultipleFileUpload;
